import { render } from "./index.vue?vue&type=template&id=af39ae02&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=af39ae02&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-af39ae02"

export default script